<template>
  <div v-if="utilizaPlataformaPagamento">
    <div class="row m-2" v-if="listAvisos.length > 0">
      <div class="col">
        <b-card :title="''">
          <b-alert show variant="warning" >
            <h4 class="alert-heading">Checklist Cadastro Empresa</h4>
            <p v-for="(aviso, i) in listAvisos" :key="i" class="font-weight-bold">
              <i class="fas fa-exclamation-circle"></i> {{aviso}}
            </p>
          </b-alert>
        </b-card>
      </div>
    </div>
    <div class="row m-2">
      <div class="col"  v-for="card in cards" :key="card.id">
        <b-card :title="card.title">
          <b v-if="card.id === 'ticketMedio'">
            {{resumo[card.id] | money}}
          </b>
          <b v-else>{{resumo[card.id]}}</b>
        </b-card>
      </div>
    </div>
    <div class="row m-2">
      <div class="col">
        <b-card title="Vendas realizadas por Mês">
          <line-chart :chart-data="datacollection" :options="options"></line-chart>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import lineChart from '@/components/chart/LineChart';
import axios from 'axios';

export default {
  async mounted(){

    var response = await axios.get(`/api/juridica/${this.empresa._id}/resumo`,{
      params: {
        vendedor: this.idVendedor
      }
    });
    this.resumo = response.data;

    this.fillData();
    this.loadAvisos();
  },
  computed:{
    empresa() {
      return this.$store.getters.empresa;
    },
    utilizaPlataformaPagamento() {
      return this.empresa.utilizaPlataformaPagamento;
    },
    idVendedor() {
      if (this.$store.getters.isVendedor) {
        return this.$store.getters.user._id;
      }
      return null;
    }
  },
  components: {
    lineChart
  },
  data() {
    return {
      resumo: null,
      datacollection: null,
      listAvisos: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        height: '200px',
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
      },
      cards: [
        {
          id: "cliente",
          title: "Total de Clientes Cadastrados",
          action: ""
        },
        {
          id: "clientePagos",
          title: "Total de Clientes Pagos",
          action: ""
        },
        {
          id: "clientesInadimplentes",
          title: "Total de Clientes Inadimplentes",
          action: ""
        },
        {
          id: "clientesAguardandoPagamento",
          title: "Total de Clientes Aguardando pagamento",
          action: ""
        },
        {
          id: "clientesCancelados",
          title: "Total de Clientes Cancelados",
          action: ""
        },
        {
          id: "ticketMedio",
          title: "Valor Plano Mais Vendido",
          action: ""
        }
      ]
    };
  },
  watch:{
    async empresa() {
      var response = await axios.get(`/api/juridica/${this.empresa._id}/resumo`);
      this.resumo = response.data;

      this.fillData();
      this.loadAvisos();
    }
  },
  methods: {
    fillData () {
      this.datacollection = {
        labels: ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO',
          'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'],
        datasets: [
          {
            label: 'Vendas realizadas',
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            data: this.resumo.totalVendasPorMes
          }
        ]
      }
    },
    async loadAvisos() {
      const avisos = await axios.get(`/api/juridica/checklist?idEmpresa=${this.empresa._id}`).then(response => response.data);
      this.listAvisos = avisos.avisos;
    }
  }
};
</script>
